<script setup lang="ts">
import { useEmitter } from "@/composition/useEmitter";
import { getOrdinal } from "@/util/methods";
import { PlusIcon } from "@gohighlevel/ghl-icons/24/outline";
import { UIButton, UITextSmMedium } from "@gohighlevel/ghl-ui";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  addSlideText: string;
  pageIndex?: number;
}>();
const emitter = useEmitter();
const { t } = useI18n();

const pageIndexOrdinal = computed(() => {
  if (props?.pageIndex === undefined) {
    return "";
  }
  return getOrdinal(props.pageIndex + 1);
});
</script>

<template>
  <div
    class="flex flex-col items-center justify-center self-stretch rounded-[8px] border border-dashed border-[#eaecf0] bg-[#f9fafb] px-0 py-[32px]"
  >
    <UITextSmMedium
      class="self-stretch text-center font-sans text-[14px] !font-[600] not-italic leading-[20px] tracking-normal text-[#101828]"
      >{{ t("survey.defaultScreenTitle") }}</UITextSmMedium
    >
    <UITextSmMedium
      class="self-stretch text-center font-sans !font-[300] not-italic !leading-[24px] tracking-normal text-gray-600"
      >{{
        t("survey.defaultScreenDescription", { pageIndex: pageIndexOrdinal })
      }}</UITextSmMedium
    >
    <UIButton
      id="add-elements-button"
      class="mt-[16px] px-[16px] py-[8px]"
      @click="emitter.emit('open-left-side-bar')"
    >
      <PlusIcon class="h-5 w-5 !text-[#344054]"></PlusIcon>
      <UITextSmMedium class="pl-[8px] !font-[600] text-[#344054]">{{
        addSlideText
      }}</UITextSmMedium>
    </UIButton>
  </div>
</template>
